import ActionButton from '@atoms/button';

import DNDBase from '@components/dnd/base';
import {
  SettingHeader,
  SettingsContainer,
  SettingsContent
} from '@components/ui/settings';

import useProcess from '@hooks/useProcess';
import { CircularProgress } from '@mui/joy';
import type { Variable } from '@stores/variables.store';
import { observer } from 'mobx-react';
import { LoaderBox } from '@/components/ui/loader';

const TraceInfo = () => {
  const process = useProcess();

  const traceInfoDnd = process?.workflows[0]?.traceInfoDnd;

  if (!process || process.isSmallProcess) {
    return (
      <LoaderBox>
        <CircularProgress />
      </LoaderBox>
    );
  }

  const onAddWindowClick = () => {
    if (!traceInfoDnd) {
      return;
    }
    const window = traceInfoDnd.createDndBlock('TI_Window', 'unrelevant');

    const dropZonePath = 'root:root|0';
    const stateWithNewWindow = traceInfoDnd.insertBlockInState(
      dropZonePath,
      traceInfoDnd.state,
      window
    );

    traceInfoDnd.setState(stateWithNewWindow);
  };

  const isDropInRoot = (path: string, item: Variable) =>
    (path.includes('root:root|') && item.type === 'Window') ||
    !path.includes('root:root|');

  return (
    <SettingsContainer>
      <SettingHeader
        description="Customize the panels available in each trace inspector"
        title="Trace Info"
      />
      {traceInfoDnd && (
        <SettingsContent>
          <div className="title-body">
            <h3>Trace Infos settings</h3>
            <ActionButton onClick={onAddWindowClick} value="Add a window" />
          </div>

          <DNDBase dnd={traceInfoDnd} restriction={isDropInRoot} />
        </SettingsContent>
      )}
    </SettingsContainer>
  );
};

export default observer(TraceInfo);
